import React from 'react';
import { Box, Flex, Text, Progress, SimpleGrid } from '@chakra-ui/react';
import { SectionCard } from './dashboardShared';

const CampaignPerformanceOverview = ({ stats }) => {
	const openRate = Number(stats.openRate || 0);
	const clickRate = Number(stats.clickRate || 0);
	const bounceRate =
		stats.emailsSent > 0 && stats.bounces
			? (stats.bounces / stats.emailsSent) * 100
			: stats.bounces === 0
				? 0
				: null;

	return (
		<SectionCard
			title='Email performance'
			description='Live metrics from your campaign analytics.'>
			<SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
				<Box>
					<Flex justify='space-between' mb={2}>
						<Text fontSize='sm' color='gray.600'>
							Open rate
						</Text>
						<Text fontSize='sm' fontWeight='bold' color='green.600'>
							{openRate.toFixed(1)}%
						</Text>
					</Flex>
					<Progress
						value={Math.min(openRate, 100)}
						colorScheme='green'
						size='md'
						borderRadius='full'
					/>
				</Box>

				<Box>
					<Flex justify='space-between' mb={2}>
						<Text fontSize='sm' color='gray.600'>
							Click rate
						</Text>
						<Text fontSize='sm' fontWeight='bold' color='teal.600'>
							{clickRate.toFixed(1)}%
						</Text>
					</Flex>
					<Progress
						value={Math.min(clickRate, 100)}
						colorScheme='teal'
						size='md'
						borderRadius='full'
					/>
				</Box>
			</SimpleGrid>

			<SimpleGrid columns={{ base: 1, sm: 3 }} spacing={4} mt={5}>
				<Box p={3} borderRadius='lg' bg='gray.50'>
					<Text fontSize='xs' color='gray.500' textTransform='uppercase'>
						Emails delivered
					</Text>
					<Text fontSize='xl' fontWeight='bold' color='gray.800'>
						{stats.emailsSent.toLocaleString()}
					</Text>
				</Box>
				<Box p={3} borderRadius='lg' bg='gray.50'>
					<Text fontSize='xs' color='gray.500' textTransform='uppercase'>
						Active campaigns
					</Text>
					<Text fontSize='xl' fontWeight='bold' color='gray.800'>
						{stats.activeCampaigns}
					</Text>
				</Box>
				<Box p={3} borderRadius='lg' bg='gray.50'>
					<Text fontSize='xs' color='gray.500' textTransform='uppercase'>
						Bounce rate
					</Text>
					<Text fontSize='xl' fontWeight='bold' color='gray.800'>
						{bounceRate != null ? `${bounceRate.toFixed(1)}%` : '—'}
					</Text>
				</Box>
			</SimpleGrid>
		</SectionCard>
	);
};

export default CampaignPerformanceOverview;
